import React from "react";
import { motion } from "framer-motion";
import one from '../assets/about/global.webp'
import smart from '../assets/about/smartlearning.webp'
import nine from '../assets/about/holistick.webp'
import strong from '../assets/about/strong.webp'
import three from '../assets/about/focus.webp'
import world from '../assets/about/global-learning-in-action.webp'
import four from '../assets/about/inernational.webp'
import five from '../assets/about/debate.webp'
import six from '../assets/about/persalized.webp'
import seven from '../assets/about/top.webp'
import eight  from '../assets/about/cultral.webp'
import eleven from '../assets/about/values.webp'
import ten  from '../assets/about/two.webp'
import twelve from '../assets/about/stem.webp'
import thirteen from '../assets/about/enrich.webp'
import fourteen  from '../assets/about/ideal.webp'
import fifteen  from '../assets/about/flexible.webp'
import sixteen  from '../assets/about/innovation.webp' 
import alumini from '../assets/about/alumini.webp'
import muns from '../assets/about/muns.webp'
import mental from '../assets/about/mental.webp'

const features = [
   {
    icon: sixteen,
    title: "Innovations and Critical Thinking",
    content:
      "Rankridge offers internationally recognized curricula such as IGCSE, Cambridge, and IB programs, giving students a competitive edge.",
  },
  {
    icon: one,
    title: "Global Curriculum for a Global Future",
    content:
      "Rankridge offers internationally recognized curricula such as IGCSE, Cambridge, and IB programs, giving students a competitive edge.",
  },
  {
    icon:three,
    title: "High-Quality Education Standards",
    content:
      "Our curriculum emphasizes conceptual understanding, inquiry-based learning, and practical application.",
  },
  {
    icon: six,
    title: "Personalized Learning for Every Child",
    content:
      "With small class sizes and attentive faculty, Rankridge provides personalized support that helps each student progress at their own pace.",
  },
  {
    icon: five,
    title: "Language Fluency and Communication Skills",
    content:
      "Students learn in an English-medium environment with additional language options, enabling fluency and multilingual communication skills.",
  },
  {
    icon: world,
    title: "World-Class Teachers",
    content:
      "Our educators bring global teaching experience and incorporate best practices that make learning engaging, inclusive, and impactful.",
  },
  {
    icon: seven,
    title: "Top Universities & \n Career-Readiness",
    content:
      "Through career counseling and academic preparation, students gain admission to top global universities with strong portfolios and life skills.",
  },
  {
    icon: eight,
    title: "Cultural Diversity and Inclusion",
    content:
      "Our diverse student community fosters cultural exchange and respect for all backgrounds, building global citizens with empathy.",
  },
  {
    icon: nine,
    title: "Holistic Education with \n Co-curricular Excellence",
    content:
      "Beyond academics, we focus on sports, arts, leadership, coding, robotics, and more—ensuring balanced, all-round development.",
  },
  {
    icon: smart,
    title: "Advanced Digital Learning",
    content:
      "Equipped with smart classrooms and e-learning platforms, Rankridge integrates technology seamlessly into daily education.",
  },
  {
    icon: twelve,
    title: "Strong STEM and 21st-Century Skills",
    content:
      "We prepare students for modern careers with hands-on STEM activities, coding, and future-ready digital competencies.",
  },
  {
    icon: eleven,
    title: "Values, Life Skills & Global Citizenship",
    content:
      "We develop character and conscience through life skills training, community work, and ethical education.",
  },
  {
    icon: mental,
    title: "Focus on Mental Health and Well-being",
    content:
      "Mindfulness sessions, counseling support, and a nurturing environment help ensure emotional well-being and resilience.",
  },
  {
    icon: four,
    title: "International Exposure & Study Tours",
    content:
      "Our students gain international exposure through exchange programs, global collaborations, and educational tours.",
  },
  {
    icon: strong,
    title: "Strong Parent Involvement",
    content:
      "We promote open communication with regular updates, meetings, and involvement in school events.",
  },
  {
    icon: muns,
    title: "MUNs & Competitions",
    content:
      "Participation in national and international contests builds leadership, teamwork, and public speaking skills.",
  },
  {
    icon: fourteen,
    title: "Ideal for Expats & Frequent Movers",
    content:
      "With a globally consistent curriculum, Rankridge suits families who relocate across regions or countries.",
  },
  {
    icon: fifteen,
    title: "Flexible Admission & Transparent Evaluation",
    content:
      "We offer rolling admissions, flexible entry points, and continuous assessments for clarity and comfort.",
  },
  {
    icon: thirteen,
    title: "Enrichment Beyond the Classroom",
    content:
      "Clubs like robotics, debating, and environmental activities offer platforms for students to pursue passions and develop confidence.",
  },
  {
    icon: alumini,
    title: "Strong Alumni Network",
    content:
      "Our alumni remain connected, offering mentorship, networking, and career support across the globe.",
  },
];
export default function Abouty() {
  return (
    <div className="min-h-screen bg-[#20b2aa] flex flex-col items-center py-1 px-1">
      {/* Top Title */}
     
                       <h6  className="text-xl text-center text-black font-extrabold mb-8 mt-2">Rankridge - The Best Schools in Hyderabad, Telangana</h6>

      {/* Image Cards */}
      <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-3 gap-1">
        {features.map((feature, idx) => (
          <motion.div
            key={idx}
            className="bg-white rounded-2xl overflow-hidden shadow-lg"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: idx * 0.2, duration: 0.6 }}
          >
            <img
              src={feature.icon}
              alt={feature.title}
              className="h-auto w-full object-contain"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-green-900">
                {feature.title.split("\n").map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
              </h3>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
